import React from 'react'
import FormInput from './FormInput'
import { Field } from 'redux-form'
import normalizeHash from 'helpers/normalizeHash'


const renderHashField = ({ input, label, type, meta: { touched, error, warning } }) => (
    <div className={(touched && error) ? 'error' : ''}>
      <div className="form__group">
        <label htmlFor="hash">lc.chat/ </label>
        <input id="hash" {...input} placeholder={label} type={type}/>
      </div>
      {touched && ((error && <span className>{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
)

const login = (authUser) => (
    <div>
      <h3 className="section__title">Looking for your previous links?</h3>
      <p className="section__subtitle">Sign up to keep track of everything you shorten. </p>
      <a onClick={() => authUser()} className="btn btn--outline">Sign up free</a>
    </div>
)

const ShortenerDetailsForm = ({ user, auth }) => (
    <div>
      <div className="shortener-form__customize layout__row section">
        <div className="layout__half section customize-link">

          <h3 className="section__title">Customize your link</h3>
          <p className="section__subtitle">Make your link memorable with a custom string.</p>
          <Field name="hash" component={renderHashField} label="customize" type="text" normalize={normalizeHash}/>


          {!user.logged_in ? login(auth) : ''}

        </div>

        <div className="layout__half">
          <h3 className="section__title">Add UTM Tags</h3>
          <p className="section__subtitle">Track your campaigns in Google Analytics to see where your traffic is
            coming from. </p>
          <FormInput id="utm_source" name="Campaign Source"
                     title="Describes the place where traffic is coming from; where the link is located."
                     placeholder="The referrer (e.g. Facebook, Google, newsletter)"/>
          <FormInput id="utm_medium" name="Campaign Medium"
                     title="How people are geting to your site; the medium being used for marketing."
                     placeholder="e.g. email, cpc, social media links, banner, etc."/>
          <FormInput id="utm_campaign" name="Campaign Name"
                     title="Name of the campaign or promotion you link to. Helps to indentify the link in your GA."
                     placeholder="Product, promo code, slogan (e.g. spring_sale)"/>
          <FormInput id="utm_term" name="Campaign Term"
                     title="This parameter let you identify the paid keywords in each ad set (ads groups). It can be a product name or discount name."
                     placeholder="e.g. blue dress, product X, etc."/>
          <FormInput id="utm_content" name="Campaign Content"
                     title="Parameter used to differentiate your group of ads. For example, you can use is to differentiate categories of products in your ads."
                     placeholder="e.g. dresses, shoes, etc."/>

        </div>
      </div>
    </div>
);


export default ShortenerDetailsForm;



// WEBPACK FOOTER //
// ./src/components/ShortenerDetailsForm.jsx